define('lq/validatorGateway',[
    'underscore'
], function (_) {

    var callbacks = [];

    return {

        loadValidator: function (config) {
            if (!window.validator) 
                postMessage({type: "LOAD_VALIDATOR", config: config}, '*');;    
        },

        isEnabled: function () {
            return !!window.validator;    
        },

        publishEvent: function (theEvent) {
            if (!window.validator) return;
            window.validator.gateway.publishEvent(theEvent);
        },

        // Responsible for pushing events to the topmost validator (important for MPAs)
        publishEventToTop: function (theEvent) {
            if (!window.top.validator) return;
            window.top.validator.gateway.publishEvent(theEvent);
        },

        registerListener: function (instanceId, callback) {
            if (!window.validator) return;
            window.validator.gateway.registerListener(instanceId, callback);
        },

        unregisterListener: function (instanceId) {
            if (!window.validator) return;
            window.validator.gateway.unregisterListener(instanceId);
        },

        whenEnabled: function (callback) {
            callbacks.push(callback);
        },

        callCallbacks: function () {
            callbacks.forEach(function (callback) {
                callback();
            });

            callbacks = [];
        },

        removeCallback: function (callbackToRemove) {
            callbacks = callbacks.filter(function (callback) {
                return callback !== callbackToRemove;
            });
        },

    };

});
